import { ProductReviewLandingView } from './ProductReviewLandingView';
import { PRECONTENT, CONTENT } from './mockedContent';

const ProductReviewLanding = () => (
  <ProductReviewLandingView precontent={PRECONTENT} content={CONTENT} />
);

export { ProductReviewLanding };
